// extracted by mini-css-extract-plugin
export default {"adminDiv":"Admin_adminDiv__2Z60F"};